module.exports = __webpack_public_path__ + "img/2.c068b2ae.png";